export { DataSource as OnboardingDataSource } from "./DataSource"
export { DataConsent as OnboardingDataConsent } from "./DataSource"
export { Nightscout as OnboardingNightscout } from "./DataSource"
export { GetStarted as OnboardingGetStarted } from "./GetStarted"
export { Ranges as OnboardingRanges } from "./Ranges"
export { UnitsOfMeasure as OnboardingUnitsOfMeasure } from "./UnitsOfMeasure"

import { AcceptInvite } from "./AcceptInvite"
import { InviteAccepted } from "./InviteAccepted"
import { PhoneCallAlerts } from "./PhoneCallAlerts"
import { Theme } from "./Theme"
import { injectProps } from "src/utils"

export const OnboardingAcceptInvite = injectProps(
  AcceptInvite,
  {
    routePrefix: "/onboarding",
    backRoutePath: "/onboarding/get_started",
  },
)

export const DataSharingAcceptInvite = injectProps(
  AcceptInvite,
  {
    routePrefix: "/data_sharing/following",
    backRoutePath: "/data_sharing/following",
  },
)

export const OnboardingInviteAccepted = injectProps(
  InviteAccepted,
  {
    routePrefix: "/onboarding",
  },
)

export const DataSharingInviteAccepted = injectProps(
  InviteAccepted,
  {
    routePrefix: "/data_sharing/following",
  },
)

export const OnboardingPhoneCallAlerts = injectProps(
  PhoneCallAlerts,
  {
    routePrefix: "/onboarding",
    backRoutePath: "/onboarding/ranges",
  },
)

export const OnboardingFollowerPhoneCallAlerts = injectProps(
  PhoneCallAlerts,
  {
    routePrefix: "/onboarding",
    backRoutePath: "/onboarding/accept_invite/$accountId/success",
  },
)

export const DataSharingFollowerPhoneCallAlerts = injectProps(
  PhoneCallAlerts,
  {
    routePrefix: "/data_sharing/following",
    backRoutePath: "/data_sharing/following/accept_invite/$accountId/success",
  },
)

export const OnboardingTheme = injectProps(
  Theme,
  {
    backRoutePath: "/onboarding/phone_call_alerts",
  },
)

export const OnboardingFollowerTheme = injectProps(
  Theme,
  {
    backRoutePath: "/onboarding/accept_invite/$accountId/phone_call_alerts",
  },
)

export const DataSharingFollowerTheme = injectProps(
  Theme,
  {
    backRoutePath: "/data_sharing/following/accept_invite/$accountId/phone_call_alerts",
  },
)
